export default __webpack_public_path__ + "static/media/detail_02.e7bae5e2.png";